import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { Toaster } from "@/components/ui/toaster";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { LoginPage } from "@/pages/LoginPage";
import { SetPasswordPage } from "@/pages/SetPasswordPage";
import { TopPage } from "@/pages/TopPage";
import { IpDetailPage } from "@/pages/IpDetailPage";
import { AdminUsersPage } from "@/pages/AdminUsersPage";

function Fallback({ error }: { error: Error }) {
  return (
    <div className="max-w-md mx-auto mt-12 space-y-4">
      <h1 className="text-lg font-semibold">予期しないエラー</h1>
      <pre className="text-xs text-muted-foreground whitespace-pre-wrap">{error.message}</pre>
      <button className="text-sm underline" onClick={() => window.location.reload()}>リロード</button>
    </div>
  );
}

const router = createBrowserRouter([
  {
    element: (
      <ErrorBoundary FallbackComponent={Fallback}>
        <Layout />
        <Toaster />
      </ErrorBoundary>
    ),
    children: [
      { path: "/login", element: <LoginPage /> },
      { path: "/set-password", element: <SetPasswordPage /> },
      { path: "/", element: <ProtectedRoute><TopPage /></ProtectedRoute> },
      { path: "/ips/:ip_id", element: <ProtectedRoute><IpDetailPage /></ProtectedRoute> },
      { path: "/admin/users", element: <ProtectedRoute requireAdmin><AdminUsersPage /></ProtectedRoute> },
      { path: "*", element: <ProtectedRoute><TopPage /></ProtectedRoute> },
    ],
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}
